import React, { useEffect, useState } from "react";
import DataTable from "../../../components/DataTable";
import { API_GET } from "../../../helpers/api";
import { setNotification } from "../../../helpers/notification";
import moment from "moment";
import { convertNumberToFrontend } from "../../../helpers/convert";
const PriceLimits = ({ t }) => {
  const [sessionData, setSessionData] = useState([]);

  const sessionsColumns = [
    {
      name: t("pages.default.systemParameters.table.organizedMarketTime"),
      selector: "sessionDate",
      sortable: false,
      cell: (row) =>
        moment(row.sessionDate)
          .locale(window.localStorage.i18nextLng)
          .format("DD.MM.YYYY - dddd"),
    },
    {
      name: t("pages.default.systemParameters.table.minimumPrice"),
      selector: "minimumPrice",
      sortable: false,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.minimumPrice, digit: 2 });
      },
    },
    {
      name: t("pages.default.systemParameters.table.maximumPrice"),
      selector: "maximumPrice",
      sortable: false,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.maximumPrice, digit: 2 });
      },
    },
  ];

  useEffect(() => {
    getSession();
    const sessionInterval = setInterval(() => {
      getSession();
    }, 5000);

    return () => clearInterval(sessionInterval);
  }, []);

  const getSession = async () => {
    try {
      let res = await API_GET("system-parameter/session");
      setSessionData(res.data.items);
    } catch (e) {
      setNotification("error", e.response.data.message);
    }
  };

  return (
    <div className="km__p--card">
      <DataTable columns={sessionsColumns} data={sessionData} />
    </div>
  );
};

export default PriceLimits;
